export default __webpack_public_path__ + "static/media/cosmos-fitness.268caac6.svg";